import { render, staticRenderFns } from "./OptionNotification.vue?vue&type=template&id=dff5d12a&"
import script from "./OptionNotification.vue?vue&type=script&lang=ts&"
export * from "./OptionNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports